
import React, { Suspense } from "react";
import { ManualPostulationInternalPage } from "@rankmi/ats-app";
import { Spin } from 'antd'

const NewApplicantFromSegment = ({ selection_process_id }) => {
  return (
    <Suspense fallback={<Spin loading={true}/>}>
      <ManualPostulationInternalPage
        onCancel={() => window.location.href = `/selection_processes/${selection_process_id}`}
        processId={selection_process_id}
      />
    </Suspense>
  );
};

export default NewApplicantFromSegment;
